import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import site from "../data/site";
import logo from "../assets/logo.webp";

export default function Footer() {
  return (
    <footer className="relative bg-charcoal text-white/90 mt-0">
      <div className="container-luxe pt-20 pb-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src={logo}
              alt="Eternal Care — Greater Houston, TX"
              className="h-28 md:h-32 w-auto object-contain rounded-lg shadow-lg"
            />
            <p className="font-script text-2xl text-rose-soft mt-5">
              {site.tagline}
            </p>
            <p className="text-white/70 mt-4 max-w-md leading-relaxed">
              A symbol of compassion, individuality and the beauty of being uniquely you.
              Dignified, personalized and heartfelt transportation in Greater Houston.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-xl text-white mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-white/75">
              <li><Link to="/about" className="hover:text-rose-soft transition-colors" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/services" className="hover:text-rose-soft transition-colors" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/faq" className="hover:text-rose-soft transition-colors" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-rose-soft transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display text-xl text-white mb-4">Reach Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-rose-soft" strokeWidth={1.5} />
                <a href={site.phoneHref} className="hover:text-rose-soft transition-colors" data-testid="footer-phone">{site.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-rose-soft" strokeWidth={1.5} />
                <a href={site.emailHref} className="hover:text-rose-soft transition-colors" data-testid="footer-email">{site.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-rose-soft" strokeWidth={1.5} />
                <span>{site.cityLine}</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-6">
              <a href={site.socials.instagram} aria-label="Instagram" className="w-9 h-9 grid place-items-center rounded-full border border-white/20 hover:bg-rose hover:border-rose transition-colors" data-testid="social-instagram">
                <Instagram className="w-4 h-4" strokeWidth={1.5} />
              </a>
              <a href={site.socials.facebook} aria-label="Facebook" className="w-9 h-9 grid place-items-center rounded-full border border-white/20 hover:bg-rose hover:border-rose transition-colors" data-testid="social-facebook">
                <Facebook className="w-4 h-4" strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between text-xs text-white/55 tracking-wider uppercase">
          <span>© {new Date().getFullYear()} Eternal Care. All rights reserved.</span>
          <span className="font-script text-rose-soft text-base normal-case tracking-normal">
            Be Proud. Be You. Be Remembered.
          </span>
        </div>
      </div>
    </footer>
  );
}
